import "../styles/previewHeader.css";

export default function PreviewHeader() {
  return (
    <header className="preview-header">
      <div className="preview-header-inner">

        <button className="preview-back" onClick={() => window.history.back()}>
          ← Start Over
        </button>

        <div className="preview-mode">Preview Mode</div>

        <a
          href="https://www.networksolutions.com/website/diy-website-builder?brand=web&siteID=100&channelID=P99C100S653N0B5A1D0E0000V100"
          target="_blank"
          rel="noopener noreferrer"
          className="preview-signup"
        >
          Sign Up Now
        </a>

      </div>
    </header>
  );
}
